import React from "react"

export default function TimeButtons({ onChange, times, day }) {
    const [selected, setSelected] = React.useState(null)

    const handleClick = (e) => {
        e.preventDefault()
        setSelected(e.target.innerText)

        onChange(e)
    }

    const buttons = times[day].map((time, i) => {
        return (
            <div key={i} onClick={handleClick} className={"card" + (selected === time ? " is--selected" : "") + " no--image"}>
                <p className="card__title">{time}</p>
            </div>
        )
    })

    return (
        <div className="cards">
            {buttons}
        </div>
    )
}